<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="acceptButton" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-active="isModalLocationVisible" :vm-title="$t('products.change_location')")
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          span {{ $t('products.location_1_placeholder') }}
          type-ahead-select(@item-select="setLocation1" @search="autoCompleteFunc" :data="locations" :defaultValue="form && form.location_1 ? form.location_1.code : ''" :isSFS="isSFS")
        b-form-group
          span {{ $t('products.location_2_placeholder') }}
          type-ahead-select(@item-select="setLocation2" @search="autoCompleteFunc" :data="locations" :defaultValue="form && form.location_2 ? form.location_2.code : ''" :isSFS="isSFS")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Products')
const TypeAheadSelect = () => import('@/components/elements/TypeAheadSelect.vue')

export default {
  name: 'ModalProductLocation',
  components: {
    TypeAheadSelect
  },
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        location_1: {
          required
        },
        location_2: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalLocationVisible', 'locations']),
    ...configMapGetters(['isSFS'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'syncRecord',
      'deleteRecord',
      'setModalLocationVisible',
      'getLocations'
    ]),
    setLocation1 (value) {
      this.form.location_1 = value.id
    },
    setLocation2 (value) {
      this.form.location_2 = value.id
    },
    acceptButton () {
      this.form = {
        ...this.form,
        location_1_id: this.form.location_1,
        location_2_id: this.form.location_2
      }
      this.editRecord(this.form).then(() => {
        this.setModalLocationVisible(false)
      })
    },
    close () {
      this.setModalLocationVisible(false)
    },
    autoCompleteFunc (value) {
      this.getLocations({ filter: `?param=${value},code`, url: 'locations' })
    }
  }
}
</script>
